import { Title } from 'src/components'
import InfoVersions from './components/InfoVersions'

const Info = () => {
  return (
    <>
      <Title label="Info" className="mb-8" />
      <InfoVersions />
    </>
  )
}

export default Info
